import { Footer, TitleBar } from '../../../../../components';
import GenericListManager from '../../../../../components/generic/ListManager/GenericListManager';
import {
  FETCH_IT_APPLICATIONS,
  GET_BUSINESS_FUNCTIONS_SELECTED_IT_APPS,
  SET_IT_APPLICATIONS_TO_BIZ_FUNCTIONS,
} from '../../../../dataInputs/queries/itApplications';
import { useParams } from 'react-router';
import TitleUpdater from '../../../../../components/common/TitleUpdater';
import { BusinessFunction } from './types';
import { useBusinessFunctionData } from '../../../../../hooks/business-functions/queries';
import {
  useBusinessFunctionApplicationWorkarounds,
  useRemoveITApplicationConfirmation,
} from '../../../location-applications/business-functions-workarounds/hooks';
import { RemoveITApplicationModal } from '../../../components/RemoveITApplicationModal';
import { GET_BUSINESS_FUNCTION_WORKAROUNDS } from '../../../location-applications/business-functions-workarounds/queries';

export type BusinessFunctionData = {
  getBusinessFunction: BusinessFunction;
};

const BusinessFunctionsTaggingITSelection = () => {
  const { businessFunctionId } = useParams();
  const { businessFunctionName } = useBusinessFunctionData(
    businessFunctionId ?? '',
  );

  const businessFunctionIds = businessFunctionId ? [businessFunctionId] : [];

  const { data: workarounds } =
    useBusinessFunctionApplicationWorkarounds(businessFunctionIds);

  const {
    isModalOpen,
    affectedApplications,
    handleBeforeUpdate,
    handleConfirm,
    handleCancel,
  } = useRemoveITApplicationConfirmation({
    workarounds: workarounds ?? [],
  });

  return (
    <div>
      <TitleUpdater title={`${businessFunctionName}/IT App Selection`} />
      <TitleBar
        title="Enterprise Business Function Tagging"
        subtitle={`${businessFunctionName} Application Tagging`}
        brief={`Select which IT applications directly support the ${businessFunctionName} function at the enterprise level.`}
      />
      <GenericListManager
        addedTitle="IT Applications Added"
        availableTitle="IT Applications Available"
        fetchAllQuery={{
          query: FETCH_IT_APPLICATIONS,
          identifier: 'findAllItApplications',
          variables: {
            data: {
              enterpriseWide: true,
            },
          },
        }}
        fetchSelectedQuery={{
          query: GET_BUSINESS_FUNCTIONS_SELECTED_IT_APPS,
          identifier: 'getBusinessFunctionsSelectedItApplications',
          variableName: '0.itApplications',
          variables: {
            data: businessFunctionIds,
            filter: {
              selected: true,
            },
          },
        }}
        itemKey="uuid"
        itemLabel="application"
        updateMutation={{
          mutation: SET_IT_APPLICATIONS_TO_BIZ_FUNCTIONS,
          variableName: 'data.businessFunctions[0].itApplications',
          variableStructure: {
            data: {
              businessFunctions: [
                {
                  itApplications: {},
                  uuid: businessFunctionId,
                },
              ],
            },
          },
          formatFunction: (item: string) => ({ uuid: item }),
        }}
        beforeUpdate={(items) => {
          return new Promise((resolve) => {
            handleBeforeUpdate(items, () => resolve(true));
          });
        }}
        refetchQueries={[
          {
            query: FETCH_IT_APPLICATIONS,
            variables: {
              data: {
                enterpriseWide: true,
              },
            },
          },
          {
            query: GET_BUSINESS_FUNCTIONS_SELECTED_IT_APPS,
            variables: {
              data: businessFunctionIds,
              filter: {
                selected: true,
              },
            },
          },
          {
            query: GET_BUSINESS_FUNCTION_WORKAROUNDS,
            variables: {
              data: {
                uuids: businessFunctionIds,
              },
            },
          },
        ]}
      />
      <RemoveITApplicationModal
        isOpen={isModalOpen}
        onCancel={handleCancel}
        onRemove={handleConfirm}
        applications={affectedApplications}
      />
      <Footer
        backPath={'/cyber/enterprise-level/business-functions'}
        nextPath={`/cyber/enterprise-level/business-functions/${businessFunctionId}/it-application-description`}
        goNextText="Add Descriptions"
      />
    </div>
  );
};

export default BusinessFunctionsTaggingITSelection;
